var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHourglass48Line = function SvgIconHourglass48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7 16.2v-2.6c0-2.92-2.38-5.3-5.3-5.3h-8.8a5.31 5.31 0 0 0-5.3 5.3v2.6c0 1.66.79 3.24 2.12 4.24L21.17 24l-4.75 3.56c-1.33 1-2.12 2.58-2.12 4.24v2.6c0 2.92 2.38 5.3 5.3 5.3h8.8c2.92 0 5.3-2.38 5.3-5.3v-2.6c0-1.66-.79-3.24-2.12-4.24L26.83 24l4.75-3.56c1.33-1 2.12-2.58 2.12-4.24Zm-4.16 14.08c.48.36.76.92.76 1.52v2.6a1.9 1.9 0 0 1-1.9 1.9h-8.8a1.9 1.9 0 0 1-1.9-1.9v-2.6c0-.59.28-1.16.76-1.52L24 26.12l5.54 4.16Zm.76-14.08c0 .59-.28 1.16-.76 1.52L24 21.88l-5.54-4.16c-.47-.36-.76-.92-.76-1.52v-2.6c0-1.05.85-1.9 1.9-1.9h8.8c1.05 0 1.9.85 1.9 1.9v2.6Z",
    fill: "current"
  })));
};
export default SvgIconHourglass48Line;